import { combineReducers } from 'redux';
import loginOrRegisterReducer from './login/reducer';
import cafesReducer from './cafes/reducer';
import userProfileReducer from './userProfile/reducer';
import favoritesReducer from './favorites/reducer';
import financialTransactionReducer from './financialTransaction/reducer';
import regionReducer from './region/reducer';
import adReducer from './ad/reducer';
import reservesReducer from './reserves/reducer';
import paymentReducer from './payment/reducer';
import commentReducer from './comment/reducer';
import passwordReducer from './password/reducer';
import channelMessageReducer from './channelMessage/reducer';
import ticketReducer from './ticket/reducer';
import introducedCafeReducer from './introducedCafe/reducer';
import amenitiesReducer from './amenity/reducer';
import packagesReducer from './packages/reducer';
import generalReducer from './general/reducer';

const reducers = combineReducers({
  loginOrRegisterReducer,
  cafesReducer,
  userProfileReducer,
  favoritesReducer,
  financialTransactionReducer,
  regionReducer,
  adReducer,
  reservesReducer,
  paymentReducer,
  commentReducer,
  passwordReducer,
  channelMessageReducer,
  ticketReducer,
  introducedCafeReducer,
  amenitiesReducer,
  packagesReducer,
  generalReducer,
});

export default reducers;
